define('collections/search',[
  "backbone"
], function (Backbone) {
  "use strict";

  return Backbone.Collection.extend({
    highlight: [],

    model: function () {
      return this.options.model;
    },

    url: function () {
      return this.options.url;
    }
  });
});

